import Constants from 'expo-constants';

// __DEV__: process.env wins; else `extra` from app.config at build time.
const getEnvVar = (key, defaultValue = '') => {
  const fromExtra = Constants.expoConfig?.extra?.[key];
  if (__DEV__ && typeof process !== 'undefined' && process.env?.[key]) {
    return process.env[key];
  }
  if (fromExtra != null && fromExtra !== '') {
    return fromExtra;
  }
  return defaultValue;
};

// Get base URL from environment
const BASE_URL = getEnvVar('API_BASE_URL', 'https://zoolyfe.id');

// API Configuration - all URLs derived from base URL
export const API_CONFIG = {
  BASE_URL: BASE_URL,
  AUTH_API_URL: `${BASE_URL}/api/auth`,
  ZCLUB_API_URL: `${BASE_URL}/api/zclub`,
  GENERAL_API_URL: `${BASE_URL}/api`,
  USER_API_URL: `${BASE_URL}/api/user`,
  CAPTCHA_API_URL: `${BASE_URL}/api/captcha`,
};

// Export individual URLs for backward compatibility
export const API_BASE_URL = API_CONFIG.BASE_URL;
export const AUTH_API_URL = API_CONFIG.AUTH_API_URL;
export const ZCLUB_API_URL = API_CONFIG.ZCLUB_API_URL;
export const GENERAL_API_URL = API_CONFIG.GENERAL_API_URL;
export const USER_API_URL = API_CONFIG.USER_API_URL;
export const CAPTCHA_API_URL = API_CONFIG.CAPTCHA_API_URL;
